<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import UserProfileBase from '../../../user/components/UserProfileBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <UserProfileBase />
</template>